import { footerColumns } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="w-full">
      <div className="w-full bg-accent-500">
        <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center justify-between gap-5 px-4 py-8 md:flex-row md:px-6">
          <div className="text-center md:text-left">
            <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">今日重磅不等人，吃瓜姿势要够快</h3>
            <p className="mt-1.5 text-sm text-foreground-800">爆料一来就上头条，实锤一出立刻更新，别错过任何一个大瓜。</p>
          </div>
          <div className="flex flex-wrap justify-center gap-3">
            <a
              href="#today"
              className="cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
            >
              回到今日重磅
            </a>
            <a
              href="#comment"
              className="cursor-pointer whitespace-nowrap rounded-md border border-foreground-950/30 bg-background-50/70 px-6 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-background-50"
            >
              去评论区围观
            </a>
          </div>
        </div>
      </div>

      <div className="w-full bg-secondary-900 pb-8 pt-12 text-background-200">
        <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-5">
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2.5">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-fire-fill text-2xl" />
                </span>
                <span className="font-heading text-xl font-black text-background-50">黑料大瓜</span>
              </div>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-background-400">
                专注热门事件的最新爆料与实锤整理，按分钟级更新，把炸裂细节和首发爆点一次讲清楚。吃瓜有度，求证有据。
              </p>
              <div className="mt-5 flex flex-wrap gap-2">
                {['今日重磅', '最新爆料', '实锤证据', '首发爆点'].map((k) => (
                  <span key={k} className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-300">
                    {k}
                  </span>
                ))}
              </div>
            </div>

            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="mb-4 font-heading text-base font-bold text-background-50">{col.title}</h4>
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a href="#today" className="cursor-pointer text-sm text-background-400 transition-colors hover:text-accent-400">
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row">
            <p>© 2026 黑料大瓜 · 本站内容为演示展示，所有事件与人物均为虚构。</p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <a href="#today" className="cursor-pointer transition-colors hover:text-accent-400">免责声明</a>
              <a href="#today" className="cursor-pointer transition-colors hover:text-accent-400">社区公约</a>
              <a href="#today" className="cursor-pointer transition-colors hover:text-accent-400">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}